import { createSlice } from "@reduxjs/toolkit";

// Создаем slice (редьюсер + экшены)
const viewsSlice = createSlice({
  name: "views",
  initialState: { value: 0 },
  reducers: {
    increment: (state) => {
      state.value += 1;
    },
    // decrement: (state) => {
    //   state.value -= 1;
    // },
  },
});

// Экшены
export const { increment } = viewsSlice.actions;

// // Store
// const store = configureStore({
//   reducer: {
//     counter: counterSlice.reducer,
//   },
// });
export default viewsSlice.reducer;
